import React from 'react';
import { useIntl } from 'react-intl';
import { ArtistPortalPlaylistRow } from 'fym-shared/src/smartlinks/artistPortals';
import { TypedMemo } from '../../../common/types';
import { formatStreamingNumber } from '../streamingFormat';
import { sourceLook } from '../streamingSources';
import { streamingCuratorMessages } from '../streamingCuratorMessages';
import { streamingBlockMessages as messages } from '../streamingBlockMessages';
import { streamingTotalLabels } from '../streamingTotalsMessages';
import { SourceMark } from './SourceMark';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PlaylistsTableProps {
  playlists: ArtistPortalPlaylistRow[];
}

/**
 * The playlists (design d3): name and curator, source, curator type, streams, skip rate and
 * followers. No source gives a skip rate today, so the column is a dash with the footnote.
 */
const PlaylistsTableComponent: React.FC<PlaylistsTableProps> = ({ playlists }) => {
  const intl = useIntl();
  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>{intl.formatMessage(messages.colPlaylist)}</th>
            <th>{intl.formatMessage(messages.colSource)}</th>
            <th>{intl.formatMessage(messages.colCurator)}</th>
            <th className={styles.numCell}>{intl.formatMessage(streamingTotalLabels.streams)}</th>
            <th className={styles.numCell}>{intl.formatMessage(messages.colSkipRate)}</th>
            <th className={styles.numCell}>{intl.formatMessage(messages.colFollowers)}</th>
          </tr>
        </thead>
        <tbody>
          {playlists.map((playlist) => (
            <tr key={`${playlist.integrationType}:${playlist.externalId}`}>
              <td>
                <b>{playlist.name}</b>
                {playlist.curatorName !== null ? (
                  <div className={styles.faint}>
                    {intl.formatMessage(messages.byCurator, { curator: playlist.curatorName })}
                  </div>
                ) : null}
              </td>
              <td>
                <span className={styles.tileFrom}>
                  <SourceMark integrationType={playlist.integrationType} />
                  {sourceLook(playlist.integrationType).shortName}
                </span>
              </td>
              <td>{intl.formatMessage(streamingCuratorMessages[playlist.curatorType])}</td>
              <td className={styles.numCell}>{formatStreamingNumber(intl, playlist.streams28d)}</td>
              <td className={styles.numCell}>—</td>
              <td className={styles.numCell}>{formatStreamingNumber(intl, playlist.followers)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const PlaylistsTable = TypedMemo(PlaylistsTableComponent);
